type Environment = 'local' | 'dev' | 'staging' | 'production'

const getEnvironment = (): Environment => {
  const host = window.location.host

  if (host.includes('localhost')) {
    return 'local'
  }

  if (host.includes('local.blueberrypediatrics.dev')) {
    return 'local'
  }

  if (host.includes('staging.app.blueberrypediatrics.com')) {
    return 'staging'
  }

  if (host.includes('previews.blueberrypediatrics.dev')) {
    return 'staging'
  }

  if (host.includes('app.blueberrypediatrics.com')) {
    return 'production'
  }

  // Unknown environment
  return 'local'
}

/**
 * The page is under test (Playwright).
 * This should match the Django settings `TESTING` flag.
 */
export const isTestMode = (): boolean => {
  return (
    document
      .querySelector('meta[name="is_test_mode"]')
      ?.getAttribute('content')
      ?.toLowerCase() === 'true'
  )
}

export const dev = import.meta.env.DEV

export const environment: Environment = getEnvironment()

export const bundledAtTimestamp = import.meta.env.BUNDLED_AT_TIMESTAMP

export const commitSha = import.meta.env.COMMIT_SHA
